(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire637e"];
var parcelRegister = parcelRequire.register;
parcelRegister("60E7M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4601de0fb5982d8a$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");
var $4601de0fb5982d8a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function ProductRecommendations(param) {
        var el = param.el, isLargeQuery = param.isLargeQuery;
        (0, $J7ygF._)(this, ProductRecommendations);
        this.el = el;
        this.isLargeQuery = isLargeQuery;
        this.init();
    }
    (0, $hvJJn._)(ProductRecommendations, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                var url = this.el.dataset.url;
                if (!url) return;
                fetch(url).then(function(response) {
                    return response.text();
                }).then(function(text) {
                    var html = document.createElement("div");
                    html.innerHTML = text;
                    var recommendations = html.querySelector(".related-products");
                    if (recommendations && recommendations.innerHTML.trim().length) _this.el.innerHTML = recommendations.innerHTML;
                }).catch(function(error) {
                    console.error("Error:", error);
                });
            }
        }
    ]);
    return ProductRecommendations;
}();

});

})();
//# sourceMappingURL=RelatedProducts.fa0a0bd2.js.map
